import Signup from '../components/signupHandler';
import FormMessageHandler from '../components/formMessageHandler';

const isEducationSignupPage = $('body').hasClass('page--education_signup');

if(isEducationSignupPage) {
  class EducationSignup {
    constructor() {
      this.signup = new Signup("educationSignupForm");
      this.institution = $('#institution', this.signup.form);
      this.formMessageHandler = new FormMessageHandler(this.signup.form);
      this.signup.mailValidate();
      this.signup.nameValidate();
      this.institutionValidation();
      this.attachEvent();
    }

    attachEvent() {
      this.signup.submitButton.on('click', (e) => {
        e.preventDefault();

        if(!this.signup.finalValidate()) {
          return false;
        }
        this.submitForm();
      });

    }

    submitForm() {
      // send gtm tracking info
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'educationSignup',
        name: 'Cacoo Education Sign Up',
      })

      this.signup.submitForm();
    }

    institutionValidation() {
      if(this.institution.val().length > 0) {
        this.formMessageHandler.showSuccess("institution");
      } else {
        this.formMessageHandler.showError("institution");
      }
    }
  }

  new EducationSignup();
}
